import { useContext } from 'react';
import { handleLogin } from 'store/reducers/authentication';
// ** Imports createContext function
import { createContext } from 'react';

// ** Imports createContextualCan function
import { createContextualCan } from '@casl/react';
import useMain from './useMain';
import { handleAlertMessage } from 'utils/common';

// ** Create Context
export const AbilityContext = createContext();

// ** Init Can Context
export const Can = createContextualCan(AbilityContext.Consumer);

export const useCheckLoginResult = () => {
  const { dispatch, useNavigate, t } = useMain();
  //   const ability = useContext(AbilityContext);
  const navigate = useNavigate();
  // ** Hooks
  return ({ res, setLoginFailMessage }) => {
    if (String(res.status).startsWith(2) && res.data?.Token) {
      const userData = {
        fullName: res.data.UserName,
        role: res.data.Role
      };
      const data = {
        userData,
        accessToken: res.data.Token,
        refreshToken: res.data.Token
      };
      dispatch(handleLogin(data));

      //   ability.update(res_ability);

      navigate('/product');

      setLoginFailMessage('');
    } else {
      handleAlertMessage({
        icon: 'error',
        showCancelButton: false,
        title: t(res?.data.Message || res?.Message)
      });
      setLoginFailMessage(t(res?.data.message || res?.Message));
    }
  };
};
